import { MeiliSearchError } from "./meilisearch-error.js";
export class MeiliSearchTimeOutError extends MeiliSearchError {
    name = "MeiliSearchTimeOutError";
    constructor(message) {
        super(message);
    }
}
